<div *ngIf='settingGroup'>
  <div class="page-header">
    <h3 class="pt-2">
      Setting Types for <span class="text-success">{{ settingGroup.name }}</span>
    </h3>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <a style="cursor: pointer" (click)="toggleForm()"><i class="fas" [ngClass]="{ 'fa-plus-circle': !addingSettingType, 'fa-minus-circle': addingSettingType }"></i> New Setting Type</a>
        </div>
        <div class="card-body" *ngIf="addingSettingType">
          <app-setting-type-form [setting_group_id]="settingGroup.id" [setting_type_id]="undefined" (formEvent)="onSettingTypeFormEvent($event)"></app-setting-type-form>
        </div>
      </div>
      <table class="table">
        <thead>
          <tr>
            <th>Id</th>
            <th></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let settingType of settingTypes">
            <td>{{ settingType.id }}</td>
            <td *ngIf="!editingSettingTypes[settingType.id]">
              <strong>{{ settingType.name }}</strong>
              <br />
              <span>{{ settingType.description }}</span>
            </td>
            <td *ngIf="!editingSettingTypes[settingType.id]">
              <div class="btn-group btn-group-sm">
                <button type="button" title="edit" (click)="editingSettingTypes[settingType.id] = true" class="btn btn-primary"><i class="fas fa-pencil-alt"></i></button>
                <button title="delete" type="button" (click)="deleteSettingType(settingType)" class="btn btn-danger"><i class="fas fa-trash"></i></button>
              </div>
            </td>
            <td colspan="2" *ngIf="editingSettingTypes[settingType.id]">
              <app-setting-type-form [setting_type_id]="settingType.id" (formEvent)="onSettingTypeFormEvent($event, settingType)"></app-setting-type-form>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
<div *ngIf='!settingGroup'>
  <div class="page-header">
    <h3 class="pt-2">
      No setting group found
    </h3>
  </div>
</div>